import { permissionEngine } from '@/core/permissions/permissionEngine';
import { useAuth } from '@/core/auth/AuthContext';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Save } from 'lucide-react';
import { AuthButton } from '@/core/permissions/AuthButton';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { InventoryForm } from '../components/InventoryForm';
import { PageHeaderNew } from '@/components/ui/PageHeaderNew';
import { InventoryNewSidebar } from './components/InventoryNewSidebar';
import { useInventoryNew } from './hooks/useInventoryNew';

export function InventoryNewPage() {
  const { profile } = useAuth();
  permissionEngine.assert(profile?.id || '', 'inventory.items.create');

 const navigate = useNavigate();
 const {
 values,
 setValues,
 imagePreview,
 setImagePreview,
 setImageFile,
 stockValue,
 lookups,
 createItem,
 isSaving,
 } = useInventoryNew();
 const [confirmOpen, setConfirmOpen] = useState(false);
 const [confirmMode, setConfirmMode] = useState<'save_and_new' | 'save_and_detail'>('save_and_detail');

 const handleSave = async () => {
 const itemId = await createItem({ keepForm: confirmMode === 'save_and_new' });
 setConfirmOpen(false);
 if (confirmMode === 'save_and_detail') {
 navigate(`/inventory/items/detail/${itemId}`);
 }
 };

 return (
 <div className="flex flex-col gap-4 pb-8">
  <PageHeaderNew 
    title="Thêm vật tư mới" 
    subtitle="Tạo danh mục vật tư dùng chung cho thi công và bảo dưỡng" 
    backUrl="/inventory/items" 
  />
 <div className="grid grid-cols-1 gap-4 xl:grid-cols-[1fr_340px]">
 <div className="min-w-0">
 <InventoryForm
 values={values}
 stockValue={stockValue}
 lookups={lookups}
 onChange={(key, value) => setValues((current) => ({ ...current, [key]: value }))}
 />
 </div>
 <div className="space-y-4">
 <InventoryNewSidebar
 imagePreview={imagePreview}
 onPickImage={(file) => {
 setImageFile(file);
 setImagePreview(file ? URL.createObjectURL(file) : '');
 }}
 note={values.note}
 onNoteChange={(note) => setValues((current) => ({ ...current, note }))}
 />
 </div>
 </div>

 {/* Actions Footer */}
 <div className="flex items-center justify-end gap-3 rounded-md border border-slate-200 bg-white p-3">
 <button
 type="button"
 onClick={() => navigate('/inventory/items')}
 className="inline-flex h-10 items-center justify-center gap-2 rounded-md border border-slate-200 bg-white px-4 sm:text-sm text-xs text-slate-700 hover:bg-slate-50 transition-colors"
 >
 Hủy bỏ
 </button>
 <AuthButton
 module="inventory.items"
 action="create"
 behavior="disable"
 type="button"
 onClick={() => {
 setConfirmMode('save_and_detail');
 setConfirmOpen(true);
 }}
 disabled={isSaving}
 className="inline-flex h-10 items-center justify-center gap-2 rounded-md bg-emerald-700 px-8 sm:text-sm text-xs text-white hover:bg-emerald-800 transition-colors"
 >
 <Save className="h-4 w-4" />
 Lưu vật tư
 </AuthButton>
 </div>

 <ConfirmDialog
 isOpen={confirmOpen}
 title="Xác nhận lưu vật tư"
 message="Dữ liệu vật tư sẽ được ghi trực tiếp vào hệ thống. Bạn có muốn tiếp tục?"
 confirmText="Lưu vật tư"
 isLoading={isSaving}
 onConfirm={handleSave}
 onClose={() => setConfirmOpen(false)}
 />
 </div>
 );
}

export default InventoryNewPage;

